import type { SVGProps } from 'react';

interface FlagPTProps extends Omit<SVGProps<SVGSVGElement>, 'aria-label'> {
  size?: number;
  'aria-label'?: string;
}

export function FlagPT({
  size = 18,
  'aria-label': ariaLabel = 'Portugal',
  ...rest
}: FlagPTProps): JSX.Element {
  const width = size;
  const height = Math.round((size * 14) / 20);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 14"
      role="img"
      aria-label={ariaLabel}
      focusable="false"
      {...rest}
    >
      <rect width="8" height="14" fill="#006600" />
      <rect x="8" width="12" height="14" fill="#d52b1e" />
      <circle cx="8" cy="7" r="3" fill="#ffd83d" stroke="#ffffff" strokeWidth="0.5" />
      <circle cx="8" cy="7" r="1.2" fill="#d52b1e" />
    </svg>
  );
}
